import { render, staticRenderFns } from "./viewCustomizedInfoModal.vue?vue&type=template&id=0bc7493f&scoped=true"
import script from "./viewCustomizedInfoModal.vue?vue&type=script&lang=js"
export * from "./viewCustomizedInfoModal.vue?vue&type=script&lang=js"
import style0 from "./viewCustomizedInfoModal.vue?vue&type=style&index=0&id=0bc7493f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7493f",
  null
  
)

export default component.exports